module.exports = __webpack_public_path__ + "img/gabinet-psychoterapia-uzaleznienia-michal-paczka.95daa271.png";